import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=24a4d088&scoped=true"
import script from "@/views/Settings/Categories/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Categories/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Categories/create-dialog.scss?vue&type=style&index=0&id=24a4d088&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a4d088",
  null
  
)

export default component.exports